'use strict';
require('../../products/CompanyProductsService.js');
function CompanyPublicationCompanyOrderEditCtrl(
  $scope,
  $stateParams,
  $translate,
  $timeout,
  CompanyPublicationCompanyOrderService,
  CompanyPublicationCompanyOrderSubcriptionService,
  publicationChild,
  isMain,
  item,
  index) {
    $scope.item = item;
    $scope.matched = false;
    function checkMatchPricelist() {
      if ($scope.currentProject && ($scope.order.project || $scope.order.customer.priceList !== null)) {
        $scope.matched = $scope.item.product.pricelist.some(function(v){
          return $scope.currentProject.id === v.priceListId;
        });
      }
    }
    
    checkMatchPricelist();
    $scope.save = function() {
      if($scope.item.productName === ''){
        $scope.item.productName = null;
      }
      if($scope.publication.type === 'ORDER_SUBCRIPTION'){
        CompanyPublicationCompanyOrderSubcriptionService.updateItem({
          companyId: $stateParams.companyId,
          publicationId: isMain ? $stateParams.publicationId : publicationChild.id,
          subcriptionId: isMain ? $scope.order.id : publicationChild.order.id,
          itemId: $scope.item.id
        }, $scope.item, function(resp){
          if(isMain){
            $scope.order.items[index] = resp;
          }else{
            $scope.children[$scope.children.indexOf(publicationChild)].order.items[index] = resp;
          }
          $timeout(function(){
            angular.element('.footable').trigger('footable_redraw');
          }, 0);
          $scope.$hide();
          $scope.updateTotal();
        });
      }else{
        CompanyPublicationCompanyOrderService.updateItem({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          orderId: $scope.order.id,
          itemId: $scope.item.id
        }, $scope.item, function(resp){
          $scope.order.items[index] = resp;
          $timeout(function(){
            angular.element('.footable').trigger('footable_redraw');
          }, 0);
          $scope.$hide();
          $scope.updateTotal();
        });
      }
    };
 }

angular.module('dokiv')
  .controller('CompanyPublicationCompanyOrderEditCtrl', ['$scope',
    '$stateParams',
    '$translate',
    '$timeout',
    'CompanyPublicationCompanyOrderService',
    'CompanyPublicationCompanyOrderSubcriptionService',
    'publicationChild',
    'isMain',
    'item',
    'index',
    CompanyPublicationCompanyOrderEditCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/companyOrder/CompanyPublicationCompanyOrderEditCtrl.js
// module id = 397
// module chunks = 0